import { render, staticRenderFns } from "./NewSplashScreen.vue?vue&type=template&id=52db51b2&scoped=true"
import script from "./NewSplashScreen.vue?vue&type=script&lang=js"
export * from "./NewSplashScreen.vue?vue&type=script&lang=js"
import style0 from "./NewSplashScreen.vue?vue&type=style&index=0&id=52db51b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52db51b2",
  null
  
)

export default component.exports